import React, { useState, useEffect, useCallback, useRef } from 'react';
import { isEqual } from 'lodash-es';
import { InputFieldV2 } from 'components/common/form-controls';
import styles from './instaTaskSideBarItemMultiSelect.styles';

export const InstaTaskSideBarItemMultiSelect = ({ item }) => {
  const [localValue, setLocalValue] = useState(item?.value);
  const [initialValue, setInitialValue] = useState(item?.value);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const prevItemValueRef = useRef(item?.value);

  useEffect(() => {
    // Only update localValue if the item.value actually changed
    if (!isEqual(prevItemValueRef.current, item?.value)) {
      setLocalValue(item?.value);
      prevItemValueRef.current = item?.value;
    }
  }, [item?.value]);

  const itemOnChange = item?.onChange;

  const handleOnChange = useCallback(
    (selectedOptions, reason) => {
      setLocalValue(selectedOptions || []);
      const shouldNotifyImmediately =
        (reason === 'removeOption' && !dropdownOpen) || reason === 'clear';

      if (shouldNotifyImmediately && itemOnChange) {
        itemOnChange(selectedOptions || []);
      }
    },
    [dropdownOpen, itemOnChange]
  );

  const handleOnClose = useCallback(() => {
    setDropdownOpen(false);
    // Only call itemOnChange if the value has actually changed
    if (itemOnChange && !isEqual(initialValue, localValue)) {
      itemOnChange(localValue);
    }
  }, [itemOnChange, initialValue, localValue]);

  const handleOnOpen = useCallback(() => {
    setInitialValue(localValue);
    setDropdownOpen(true);
  }, [localValue]);

  return (
    <InputFieldV2
      type="multiselect"
      options={item?.options || []}
      value={localValue}
      variant="filled"
      sx={styles.textfield}
      onChange={handleOnChange}
      limitTags={item?.limitTags || 1}
      onInputChange={item?.onInputChange}
      onOpen={handleOnOpen}
      onClose={handleOnClose}
    />
  );
};
